import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'ums/v1/analytics/products/categories';
export const getProductsCategoriesCountsEndpointIdentifier = endpoint;

export interface ProductsCategoriesCountsDataset {
  l3CategoryTitle: string;
  count: number;
}

export interface ProductsCategoriesCountsData {
  id: number;
  title: string;
  dataset: ProductsCategoriesCountsDataset[];
}

type TData = Record<string, any>;
type TError = AxiosError;
type TQueryKey = [typeof endpoint];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetProductsCategoriesCountsApi(options?: Options): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(endpoint);

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useQueryWrapper([endpoint], queryFn, {
    enabled: isLoggedIn,
    ...options,
  });
}
